export default {
  sort: 'sort',
  page: 'page',
  perPage: 'per_page'
}



// WEBPACK FOOTER //
// ./src/vuestic-theme/vuestic-components/vuestic-datatable/data/query-params.js